module.exports = "\n<div>\n\n  <span class=\"spinner\"></span>\n  <span class=\"description\">{{(message || '') | translate}}</span>\n\n</div>\n"